import { HelperArticle, HelperPage, HelperPages } from "./models";

export function isHelperArticle(
  data?: HelperArticle | null,
): data is HelperArticle {
  return (
    !!data &&
    "id" in data &&
    data.id !== undefined &&
    "name" in data &&
    data.name !== undefined &&
    "description" in data &&
    data.description !== undefined &&
    "content" in data &&
    data.content !== undefined &&
    "status" in data &&
    data.status !== undefined &&
    "locale" in data &&
    data.locale !== undefined &&
    "total_feedback" in data &&
    data.total_feedback !== undefined &&
    "ratio_positive_feedback" in data &&
    data.ratio_positive_feedback !== undefined &&
    "user" in data &&
    data.user !== undefined
  );
}

export function isHelperPage(data?: HelperPage | null): data is HelperPage {
  return (
    !!data &&
    "id" in data &&
    data.id !== undefined &&
    "name" in data &&
    data.name !== undefined &&
    "uri" in data &&
    data.uri !== undefined &&
    "articles" in data &&
    data.articles !== undefined &&
    "total_articles" in data &&
    data.total_articles !== undefined &&
    "status" in data &&
    data.status !== undefined
  );
}

export function isHelperPages(data?: HelperPages | null): data is HelperPages {
  return (
    !!data &&
    "helperPages" in data &&
    data.helperPages !== undefined &&
    "isCollection" in data &&
    data.isCollection !== undefined &&
    "pagination" in data &&
    data.pagination !== undefined &&
    "ressourceName" in data &&
    data.ressourceName !== undefined &&
    "status" in data &&
    data.status !== undefined
  );
}

export function isHelperArticleList(
  data: HelperArticle[],
): data is HelperArticle[] {
  return Array.isArray(data) && data.every(isHelperArticle);
}
